import Tilt from 'react-parallax-tilt';

// We pass in "props" (properties) so each card can display different text
export default function ArtCard({ title, img }) {
  return (
    <Tilt 
  glareEnable={true} 
  glareMaxOpacity={0.3} 
  glareColor="#ffffff" 
  glarePosition="all"
  className="w-64 aspect-[5/7] bg-gray-800 rounded-xl border-4 border-yellow-500 shadow-[0_20px_50px_rgba(0,0,0,0.7)] flex flex-col items-center justify-center text-white cursor-pointer transition-shadow hover:shadow-[0_30px_60px_rgba(0,255,0,0.3)]"
  style={{ backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center", 
  imageRendering: "pixelated" }}
>
  <div className="text-center pointer-events-none p-4">
    <p className="text-2xl font-bold text-amber-400 drop-shadow-md">{title}</p>
  </div>
</Tilt>
  );
}